import React from 'react';

// wrapper around main app area
export const MainWrapper = ({ children }) => {
  return (
    <div className="sb-col">
      <div className="sb-main-content">{children}</div>
    </div>
  );
};
